import { toRef } from 'vue';

export default function propsToRefs(props = {}, keys = []) {
  const refs = [];
  keys.forEach((key) => {
    refs.push(toRef(props, key));
  });
  return refs;
}
